import { readCache, writeCache } from './dataCache';

function profileCacheKey(uid) {
  return `lockedin_profile_cache_${uid}`;
}

/** @returns {{ profile: object | null, lastUpdated: number | null }} */
export function loadCachedProfile(uid) {
  if (!uid) return { profile: null, lastUpdated: null };
  const { data, lastUpdated } = readCache(profileCacheKey(uid));
  return { profile: data ?? null, lastUpdated };
}

export function saveCachedProfile(uid, profile) {
  if (!uid || !profile) return;
  writeCache(profileCacheKey(uid), profile);
}
